import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiShield, FiUser, FiClock, FiArrowRight, FiActivity, FiKey, FiLock, FiAlertTriangle } = FiIcons;
import { mockAuditLogs } from '../data/mockData';

const Audit = () => {
  const getActionIcon = (action) => {
    if (action.includes('Key')) return FiKey;
    if (action.includes('Vault')) return FiLock;
    if (action.includes('Limit')) return FiActivity;
    if (action.includes('Provider')) return FiIcons.FiServer;
    return FiShield;
  };

  return (
    <div className="space-y-6 animate-in fade-in duration-700">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Global Audit Trail</h2>
          <p className="text-sm text-slate-500">Immutable record of all administrative and security actions.</p>
        </div>
        <button className="px-4 py-2 bg-slate-900 text-white text-xs font-bold rounded-xl hover:bg-slate-800 transition-all flex items-center gap-2 shadow-md">
          <SafeIcon icon={FiIcons.FiDownload} /> Export Compliance Log
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-slate-50 text-[10px] uppercase text-slate-500 font-bold border-b border-slate-100">
                <th className="px-6 py-4">Action Event</th>
                <th className="px-6 py-4">Target Resource</th>
                <th className="px-6 py-4">Actor</th>
                <th className="px-6 py-4">Timestamp</th>
                <th className="px-6 py-4">Status</th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-slate-50">
              {mockAuditLogs.map(log => (
                <tr key={log.id} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center">
                        <SafeIcon icon={getActionIcon(log.action)} />
                      </div>
                      <span className="font-bold text-slate-800">{log.action}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-slate-600 font-medium">{log.target}</td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <SafeIcon icon={FiUser} className="text-slate-400" />
                      <span className="text-xs text-slate-700">{log.user}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2 text-slate-400 font-mono text-[11px]">
                      <SafeIcon icon={FiClock} />
                      {log.time}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${log.status === 'Success' ? 'bg-emerald-50 text-emerald-700' : 'bg-red-50 text-red-700'}`}>
                      {log.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-4 shadow-sm">
          <SafeIcon icon={FiAlertTriangle} className="text-amber-600 text-xl" />
          <div className="space-y-1">
            <h4 className="text-sm font-bold text-amber-900">Retention Policy</h4>
            <p className="text-xs text-amber-800 leading-relaxed">
              Audit records are retained for 365 days in accordance with BPA Global Security Policy. Records older than 1 year are archived to cold storage.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Audit;